// src/app/modules/Auth/components/PasswordStrengthMeter.js
import React from "react";

const RULES = [
  { label: "Minimal 12 karakter", test: (v) => v.length >= 12 },
  { label: "Huruf besar (A-Z)", test: (v) => /[A-Z]/.test(v) },
  { label: "Huruf kecil (a-z)", test: (v) => /[a-z]/.test(v) },
  { label: "Angka (0-9)", test: (v) => /[0-9]/.test(v) },
  { label: "Simbol (contoh: !@#$)", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export default function PasswordStrengthMeter({ value, light }) {
  if (!value) return null;

  const passed = RULES.filter((rule) => rule.test(value)).length;
  const isStrong = passed === RULES.length;
  const unmetClass = light ? "text-muted" : "text-white-50";

  return (
    <div className="mb-3">
      <div className="progress" style={{ height: 4 }}>
        <div
          className={`progress-bar ${isStrong ? "bg-success" : "bg-warning"}`}
          role="progressbar"
          style={{ width: `${(passed / RULES.length) * 100}%` }}
        />
      </div>
      <div className="row mt-1 mx-0">
        {RULES.map((rule) => {
          const ok = rule.test(value);
          return (
            <div className="col-6 pl-0" key={rule.label}>
              <small className={ok ? "text-success" : unmetClass}>
                {ok ? "✓" : "✗"} {rule.label}
              </small>
            </div>
          );
        })}
      </div>
    </div>
  );
}
